import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { useScrollContext } from "@navigations/utils/ScrollContext";
import React, { useState } from "react";
import { TouchableOpacity, Platform } from "react-native";
import styled, { useTheme } from "styled-components/native";
import FavoriteButton from "../GalleryView/utils/FavoriteButton";
import { GalleryCategory } from "../GalleryView/utils/GalleryType";
import ShareModal from "../Share";
import { ShareType } from "../Share/types";
import { VDBIcons } from "@utils/VDBIcons";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import ShareMenu from "../ShareMenu";
import ShareMenuiPadWrapper from "../ShareMenuiPadWrapper";
import { ProductCategory } from "@utils/constants";

type GalleryViewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  ReceivedMedia: any;
  initialIndex?: number;
  image_thumb_url?: string;
  productType: ProductCategory;
  itemDetail?: any;
  fromMatchPair?: boolean;
  fromPDPScreen?: boolean;
  isSmallDeviceWidth?: boolean;
  handleOpenExpandModel?: any;
  mediaUrl?: any;
};

const GalleryIconsMatchView = ({
  isOpen,
  productType,
  itemDetail,
  fromMatchPair,
  fromPDPScreen,
  isSmallDeviceWidth = false,
  handleOpenExpandModel,
  mediaUrl,
}: GalleryViewModalProps) => {
  const theme = useTheme();
  const [scrollValue, ___, _____, ______, _______] = useScrollContext();
  const userInfo = useUserInfo();
  let resizeImage = false;
  let isExternalView = GalleryCategory.ModelView;

  const [showShareModal, setshowShareModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const isIPad = Platform.OS === "ios" && theme.isTablet;
  const StyledRowView =
    fromMatchPair && theme.isMobile ? RowView : React.Fragment;

  const expadViewData = () => {
    handleOpenExpandModel();
  };

  return (
    <>
      <CenterContainer>
        {!userInfo.isIFrame() && (
          <HeaderTopTextContainer
            isExternalView={isExternalView}
            fromMatchPair={fromMatchPair}
            fromPDPScreen={fromPDPScreen}
          >
            <TouchableOpacity
              onPress={() => expadViewData()}
              activeOpacity={0.8}
            >
              <IconContainer>
                <VDBIcon
                  name={VDBIcons.EXPAND}
                  size={24}
                  color={theme["core-06"]}
                  variant={IconsVariant.VDBCustom}
                />
              </IconContainer>
            </TouchableOpacity>
            <StyledRowView>
              {isIPad ? (
                <ShareMenuiPadWrapper
                  setSelectedOption={setSelectedOption}
                  setshowShareModal={setshowShareModal}
                  showExpand={true}
                  isOpen={isOpen}
                  isSmallDeviceWidth={isSmallDeviceWidth}
                  resizeImage={resizeImage}
                  itemDetail={itemDetail}
                  mediaUrl={mediaUrl}
                  productType={productType}
                />
              ) : (
                <ShareMenu
                  setSelectedOption={setSelectedOption}
                  setshowShareModal={setshowShareModal}
                  showExpand={true}
                  isOpen={isOpen}
                  isSmallDeviceWidth={isSmallDeviceWidth}
                  resizeImage={resizeImage}
                  itemDetail={itemDetail}
                  mediaUrl={mediaUrl}
                  productType={productType}
                />
              )}
              <FavoriteButton
                productType={productType}
                itemDetail={itemDetail}
                scrollValue={scrollValue}
                isMatchPairScreen={isSmallDeviceWidth}
                isOpen={isOpen}
                showExpand={true}
                resizeImage={resizeImage}
              />
            </StyledRowView>
          </HeaderTopTextContainer>
        )}
      </CenterContainer>
      <ShareModal
        isOpen={showShareModal}
        onClose={() => setshowShareModal(false)}
        item={itemDetail}
        shareType={ShareType.singleShare}
        selectedOption={selectedOption}
      />
    </>
  );
};

const CenterContainer = styled.View`
  width: 100%;
  background-color: ${({ theme }) => theme["core-01"]};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const HeaderTopTextContainer = styled.View<{
  isExternalView: keyof typeof GalleryCategory;
  fromMatchPair?: any;
  fromPDPScreen?: any;
}>`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: ${({ theme, isExternalView, fromMatchPair }) =>
    !theme.isMobile &&
    isExternalView === GalleryCategory.ModelView &&
    fromMatchPair
      ? "50%"
      : "100%"};
`;

const IconContainer = styled.View<any>`
  background-color: ${({ theme, backgroundcolor }) => theme[backgroundcolor]};
  margin: 8px;
`;

const RowView = styled.View`
  flex-direction: row;
`;

export default GalleryIconsMatchView;
